import type { ChatReactionEmoji, ChatReactionEntry, ChatTimelineItem } from '../models/Chat';

export type ChatItemReactionState = Pick<ChatTimelineItem, 'reactions' | 'reactionEmoji'>;

/** Optimistic local state after the viewer sets or replaces their reaction. */
export function withViewerReaction(
  state: ChatItemReactionState,
  viewerUserId: string,
  emoji: ChatReactionEmoji
): ChatItemReactionState {
  return {
    reactionEmoji: emoji,
    reactions: [
      ...state.reactions.filter((reaction) => reaction.userId !== viewerUserId),
      { userId: viewerUserId, emoji },
    ],
  };
}

/** Optimistic local state after the viewer clears their reaction. */
export function withoutViewerReaction(
  state: ChatItemReactionState,
  viewerUserId: string
): ChatItemReactionState {
  return {
    reactionEmoji: null,
    reactions: state.reactions.filter((reaction) => reaction.userId !== viewerUserId),
  };
}

export function isViewerReaction(
  reaction: ChatReactionEntry,
  viewerUserId: string | undefined
): boolean {
  return Boolean(viewerUserId && reaction.userId === viewerUserId);
}
